/**
 * BundleSuite BYOB — sale-only DISPLAY remap.
 * Shows total savings (product compare-at + bundle) on the two header tier labels.
 * Does not change the real 12.5% / 25% discounts.
 *
 * REVERT AFTER SALE (either):
 * 1. Set ENABLED to false below, save, push; or
 * 2. Delete this file and remove its script tag in layout/theme.liquid
 */
(function () {
  const ENABLED = true;
  const CONTAINER = '.bundlesuite-container';
  const TITLE = '.discount-info-item-title';

  let observer = null;
  let eventsBound = false;
  let applying = false;
  let scheduled = false;

  function rewrite(text) {
    if (!text) return text;
    return text
      .replace(/12\.5\s*%/g, '30%')
      .replace(/(^|[^\d.])25\s*%/g, '$140%');
  }

  function apply() {
    if (!ENABLED || applying) return;
    const root = document.querySelector(CONTAINER);
    if (!root) return;

    applying = true;
    if (observer) observer.disconnect();

    root.querySelectorAll(TITLE).forEach(el => {
      const target = el.querySelector('h3') || el;
      const next = rewrite(target.textContent);
      if (next && next !== target.textContent) target.textContent = next;
    });

    applying = false;
    bindObserver();
  }

  function scheduleApply() {
    if (applying || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  }

  function bindObserver() {
    const root = document.querySelector(`${CONTAINER} .template-top-data-discount-info`);
    if (!root || typeof MutationObserver === 'undefined') return;

    if (!observer) {
      observer = new MutationObserver(scheduleApply);
    }

    observer.observe(root, { childList: true, subtree: true });
  }

  function bindEvents() {
    if (eventsBound) return;
    eventsBound = true;
    document.addEventListener('bundleInitialized', scheduleApply);
  }

  function init() {
    if (!ENABLED || !document.querySelector(CONTAINER)) return;
    bindEvents();
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('bundleInitialized', init);
})();
